/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getConcept = /* GraphQL */ `query GetConcept($id: ID!) {
  getConcept(id: $id) {
    id
    accountID
    name
    description
    logo
    type
    location
    precedence
    longitude
    latitude
    contactWhatsApp
    contactPhoneNumber
    contactEmail
    enableOhipIntegration
    ohipClientId
    ohipClientSecret
    ohipAuthUrl
    ohipApiBaseUrl
    ohipHotelId
    ohipAppKey
    ohipEnterpriseId
    ohipExternalSystem
    ohipScope
    ohipUsername
    ohipPassword
    ohipGrantType
    senderEmail
    whatsappToken
    whatsappApiUrl
    whatsappPhoneId
    autoReplyEnabled
    autoReplyText
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConceptQueryVariables,
  APITypes.GetConceptQuery
>;
export const listConcepts = /* GraphQL */ `query ListConcepts(
  $filter: ModelConceptFilterInput
  $limit: Int
  $nextToken: String
) {
  listConcepts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      name
      description
      logo
      type
      location
      precedence
      longitude
      latitude
      contactWhatsApp
      contactPhoneNumber
      contactEmail
      enableOhipIntegration
      ohipClientId
      ohipClientSecret
      ohipAuthUrl
      ohipApiBaseUrl
      ohipHotelId
      ohipAppKey
      ohipEnterpriseId
      ohipExternalSystem
      ohipScope
      ohipUsername
      ohipPassword
      ohipGrantType
      senderEmail
      whatsappToken
      whatsappApiUrl
      whatsappPhoneId
      autoReplyEnabled
      autoReplyText
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConceptsQueryVariables,
  APITypes.ListConceptsQuery
>;
export const getUserConcepts = /* GraphQL */ `query GetUserConcepts($id: ID!) {
  getUserConcepts(id: $id) {
    id
    defaultConcept
    concepts
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserConceptsQueryVariables,
  APITypes.GetUserConceptsQuery
>;
export const listUserConcepts = /* GraphQL */ `query ListUserConcepts(
  $filter: ModelUserConceptsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserConcepts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      defaultConcept
      concepts
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserConceptsQueryVariables,
  APITypes.ListUserConceptsQuery
>;
export const getAdminRole = /* GraphQL */ `query GetAdminRole($id: ID!) {
  getAdminRole(id: $id) {
    id
    name
    description
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminRoleQueryVariables,
  APITypes.GetAdminRoleQuery
>;
export const listAdminRoles = /* GraphQL */ `query ListAdminRoles(
  $filter: ModelAdminRoleFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminRolesQueryVariables,
  APITypes.ListAdminRolesQuery
>;
export const getAdminGroup = /* GraphQL */ `query GetAdminGroup($id: ID!) {
  getAdminGroup(id: $id) {
    id
    name
    description
    roles
    users
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminGroupQueryVariables,
  APITypes.GetAdminGroupQuery
>;
export const listAdminGroups = /* GraphQL */ `query ListAdminGroups(
  $filter: ModelAdminGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listAdminGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      roles
      users
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminGroupsQueryVariables,
  APITypes.ListAdminGroupsQuery
>;
export const adminGroupsByDeleted = /* GraphQL */ `query AdminGroupsByDeleted(
  $deleted: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAdminGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  adminGroupsByDeleted(
    deleted: $deleted
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      roles
      users
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AdminGroupsByDeletedQueryVariables,
  APITypes.AdminGroupsByDeletedQuery
>;
export const getAccount = /* GraphQL */ `query GetAccount($id: ID!) {
  getAccount(id: $id) {
    id
    domain
    siteTitle
    guestsCount
    tagline
    description
    siteAddress
    defaultLanguage
    languages
    features
    status
    socialLinks
    currency
    merchantVersion
    merchantID
    merchantIframe
    merchantIntegrationNumber
    merchantAPIKey
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountQueryVariables,
  APITypes.GetAccountQuery
>;
export const listAccounts = /* GraphQL */ `query ListAccounts(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      domain
      siteTitle
      guestsCount
      tagline
      description
      siteAddress
      defaultLanguage
      languages
      features
      status
      socialLinks
      currency
      merchantVersion
      merchantID
      merchantIframe
      merchantIntegrationNumber
      merchantAPIKey
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountsQueryVariables,
  APITypes.ListAccountsQuery
>;
export const getReservation = /* GraphQL */ `query GetReservation($id: ID!) {
  getReservation(id: $id) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    guestEmail
    confirmationNumber
    eventPrimaryKey
    status
    arrivalDate
    departureDate
    isCheckInGreetingSent
    isCheckOutGreetingSent
    isEmailSent
    emailNotSentReason
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReservationQueryVariables,
  APITypes.GetReservationQuery
>;
export const listReservations = /* GraphQL */ `query ListReservations(
  $filter: ModelReservationFilterInput
  $limit: Int
  $nextToken: String
) {
  listReservations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      guestEmail
      confirmationNumber
      eventPrimaryKey
      status
      arrivalDate
      departureDate
      isCheckInGreetingSent
      isCheckOutGreetingSent
      isEmailSent
      emailNotSentReason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReservationsQueryVariables,
  APITypes.ListReservationsQuery
>;
export const reservationsByConceptId = /* GraphQL */ `query ReservationsByConceptId(
  $conceptId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReservationFilterInput
  $limit: Int
  $nextToken: String
) {
  reservationsByConceptId(
    conceptId: $conceptId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      guestEmail
      confirmationNumber
      eventPrimaryKey
      status
      arrivalDate
      departureDate
      isCheckInGreetingSent
      isCheckOutGreetingSent
      isEmailSent
      emailNotSentReason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReservationsByConceptIdQueryVariables,
  APITypes.ReservationsByConceptIdQuery
>;
export const reservationsByGuestPhoneNumber = /* GraphQL */ `query ReservationsByGuestPhoneNumber(
  $guestPhoneNumber: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReservationFilterInput
  $limit: Int
  $nextToken: String
) {
  reservationsByGuestPhoneNumber(
    guestPhoneNumber: $guestPhoneNumber
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      guestEmail
      confirmationNumber
      eventPrimaryKey
      status
      arrivalDate
      departureDate
      isCheckInGreetingSent
      isCheckOutGreetingSent
      isEmailSent
      emailNotSentReason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReservationsByGuestPhoneNumberQueryVariables,
  APITypes.ReservationsByGuestPhoneNumberQuery
>;
export const reservationsByConfirmationNumber = /* GraphQL */ `query ReservationsByConfirmationNumber(
  $confirmationNumber: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReservationFilterInput
  $limit: Int
  $nextToken: String
) {
  reservationsByConfirmationNumber(
    confirmationNumber: $confirmationNumber
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      guestEmail
      confirmationNumber
      eventPrimaryKey
      status
      arrivalDate
      departureDate
      isCheckInGreetingSent
      isCheckOutGreetingSent
      isEmailSent
      emailNotSentReason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReservationsByConfirmationNumberQueryVariables,
  APITypes.ReservationsByConfirmationNumberQuery
>;
export const reservationsByEventPrimaryKey = /* GraphQL */ `query ReservationsByEventPrimaryKey(
  $eventPrimaryKey: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReservationFilterInput
  $limit: Int
  $nextToken: String
) {
  reservationsByEventPrimaryKey(
    eventPrimaryKey: $eventPrimaryKey
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      guestEmail
      confirmationNumber
      eventPrimaryKey
      status
      arrivalDate
      departureDate
      isCheckInGreetingSent
      isCheckOutGreetingSent
      isEmailSent
      emailNotSentReason
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReservationsByEventPrimaryKeyQueryVariables,
  APITypes.ReservationsByEventPrimaryKeyQuery
>;
export const getRating = /* GraphQL */ `query GetRating($id: ID!) {
  getRating(id: $id) {
    id
    conceptId
    operaHotelId
    guestName
    guestPhoneNumber
    conversationId
    reservationId
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRatingQueryVariables, APITypes.GetRatingQuery>;
export const listRatings = /* GraphQL */ `query ListRatings(
  $filter: ModelRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  listRatings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      conversationId
      reservationId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRatingsQueryVariables,
  APITypes.ListRatingsQuery
>;
export const ratingsByConceptId = /* GraphQL */ `query RatingsByConceptId(
  $conceptId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  ratingsByConceptId(
    conceptId: $conceptId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      conversationId
      reservationId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RatingsByConceptIdQueryVariables,
  APITypes.RatingsByConceptIdQuery
>;
export const ratingsByConversationId = /* GraphQL */ `query RatingsByConversationId(
  $conversationId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  ratingsByConversationId(
    conversationId: $conversationId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      conversationId
      reservationId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RatingsByConversationIdQueryVariables,
  APITypes.RatingsByConversationIdQuery
>;
export const ratingsByReservationId = /* GraphQL */ `query RatingsByReservationId(
  $reservationId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRatingFilterInput
  $limit: Int
  $nextToken: String
) {
  ratingsByReservationId(
    reservationId: $reservationId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      operaHotelId
      guestName
      guestPhoneNumber
      conversationId
      reservationId
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RatingsByReservationIdQueryVariables,
  APITypes.RatingsByReservationIdQuery
>;
export const getConversation = /* GraphQL */ `query GetConversation($id: ID!) {
  getConversation(id: $id) {
    id
    conceptId
    guestPhoneNumber
    guestEmail
    whatsappId
    guestName
    reservationId
    confirmationNumber
    status
    assignedToId
    assignedToName
    lastMessageAt
    lastMessagePreview
    unreadCount
    messageCount
    tags
    feedback
    feedbackScore
    feedbackSubmittedAt
    source
    channel
    language
    notes
    deleted
    createdAt
    updatedAt
    createdByID
    createdByName
    messages {
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetConversationQueryVariables,
  APITypes.GetConversationQuery
>;
export const listConversations = /* GraphQL */ `query ListConversations(
  $filter: ModelConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptId
      guestPhoneNumber
      guestEmail
      whatsappId
      guestName
      reservationId
      confirmationNumber
      status
      assignedToId
      assignedToName
      lastMessageAt
      lastMessagePreview
      unreadCount
      messageCount
      tags
      feedback
      feedbackScore
      feedbackSubmittedAt
      source
      channel
      language
      notes
      deleted
      createdAt
      updatedAt
      createdByID
      createdByName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListConversationsQueryVariables,
  APITypes.ListConversationsQuery
>;
export const conversationsByConceptId = /* GraphQL */ `query ConversationsByConceptId(
  $conceptId: String!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  conversationsByConceptId(
    conceptId: $conceptId
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      guestPhoneNumber
      guestEmail
      whatsappId
      guestName
      reservationId
      confirmationNumber
      status
      assignedToId
      assignedToName
      lastMessageAt
      lastMessagePreview
      unreadCount
      messageCount
      tags
      feedback
      feedbackScore
      feedbackSubmittedAt
      source
      channel
      language
      notes
      deleted
      createdAt
      updatedAt
      createdByID
      createdByName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConversationsByConceptIdQueryVariables,
  APITypes.ConversationsByConceptIdQuery
>;
export const conversationsByGuestPhoneNumber = /* GraphQL */ `query ConversationsByGuestPhoneNumber(
  $guestPhoneNumber: String!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  conversationsByGuestPhoneNumber(
    guestPhoneNumber: $guestPhoneNumber
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      guestPhoneNumber
      guestEmail
      whatsappId
      guestName
      reservationId
      confirmationNumber
      status
      assignedToId
      assignedToName
      lastMessageAt
      lastMessagePreview
      unreadCount
      messageCount
      tags
      feedback
      feedbackScore
      feedbackSubmittedAt
      source
      channel
      language
      notes
      deleted
      createdAt
      updatedAt
      createdByID
      createdByName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConversationsByGuestPhoneNumberQueryVariables,
  APITypes.ConversationsByGuestPhoneNumberQuery
>;
export const conversationsByReservationId = /* GraphQL */ `query ConversationsByReservationId(
  $reservationId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  conversationsByReservationId(
    reservationId: $reservationId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      guestPhoneNumber
      guestEmail
      whatsappId
      guestName
      reservationId
      confirmationNumber
      status
      assignedToId
      assignedToName
      lastMessageAt
      lastMessagePreview
      unreadCount
      messageCount
      tags
      feedback
      feedbackScore
      feedbackSubmittedAt
      source
      channel
      language
      notes
      deleted
      createdAt
      updatedAt
      createdByID
      createdByName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConversationsByReservationIdQueryVariables,
  APITypes.ConversationsByReservationIdQuery
>;
export const conversationsByConfirmationNumber = /* GraphQL */ `query ConversationsByConfirmationNumber(
  $confirmationNumber: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  conversationsByConfirmationNumber(
    confirmationNumber: $confirmationNumber
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      guestPhoneNumber
      guestEmail
      whatsappId
      guestName
      reservationId
      confirmationNumber
      status
      assignedToId
      assignedToName
      lastMessageAt
      lastMessagePreview
      unreadCount
      messageCount
      tags
      feedback
      feedbackScore
      feedbackSubmittedAt
      source
      channel
      language
      notes
      deleted
      createdAt
      updatedAt
      createdByID
      createdByName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConversationsByConfirmationNumberQueryVariables,
  APITypes.ConversationsByConfirmationNumberQuery
>;
export const getMessage = /* GraphQL */ `query GetMessage($id: ID!) {
  getMessage(id: $id) {
    id
    conceptId
    conversationId
    whatsappMessageId
    direction
    messageType
    text
    status
    whatsappTimestamp
    replyToMessageId
    replyToMessage {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    forwarded
    senderId
    senderName
    senderType
    readAt
    deliveredAt
    errorCode
    errorMessage
    metadata
    deleted
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessageQueryVariables,
  APITypes.GetMessageQuery
>;
export const listMessages = /* GraphQL */ `query ListMessages(
  $filter: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMessagesQueryVariables,
  APITypes.ListMessagesQuery
>;
export const messagesByConceptId = /* GraphQL */ `query MessagesByConceptId(
  $conceptId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  messagesByConceptId(
    conceptId: $conceptId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessagesByConceptIdQueryVariables,
  APITypes.MessagesByConceptIdQuery
>;
export const messagesByConversationId = /* GraphQL */ `query MessagesByConversationId(
  $conversationId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  messagesByConversationId(
    conversationId: $conversationId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessagesByConversationIdQueryVariables,
  APITypes.MessagesByConversationIdQuery
>;
export const messagesByWhatsappId = /* GraphQL */ `query MessagesByWhatsappId(
  $whatsappMessageId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  messagesByWhatsappId(
    whatsappMessageId: $whatsappMessageId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      conversationId
      whatsappMessageId
      direction
      messageType
      text
      status
      whatsappTimestamp
      replyToMessageId
      forwarded
      senderId
      senderName
      senderType
      readAt
      deliveredAt
      errorCode
      errorMessage
      metadata
      deleted
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessagesByWhatsappIdQueryVariables,
  APITypes.MessagesByWhatsappIdQuery
>;
export const getMessaging = /* GraphQL */ `query GetMessaging($id: ID!) {
  getMessaging(id: $id) {
    id
    conceptId
    operaHotelId
    trigger
    channel
    description
    precedence
    delayMinutes
    subject
    messageTemplate
    header
    footer
    templateName
    templateLanguage
    sendRatingAfter
    ratingLink
    isActive
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    updatedByID
    updatedByName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMessagingQueryVariables,
  APITypes.GetMessagingQuery
>;
export const listMessagings = /* GraphQL */ `query ListMessagings(
  $filter: ModelMessagingFilterInput
  $limit: Int
  $nextToken: String
) {
  listMessagings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      conceptId
      operaHotelId
      trigger
      channel
      description
      precedence
      delayMinutes
      subject
      messageTemplate
      header
      footer
      templateName
      templateLanguage
      sendRatingAfter
      ratingLink
      isActive
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      updatedByID
      updatedByName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMessagingsQueryVariables,
  APITypes.ListMessagingsQuery
>;
export const messagingByConceptId = /* GraphQL */ `query MessagingByConceptId(
  $conceptId: String!
  $trigger: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMessagingFilterInput
  $limit: Int
  $nextToken: String
) {
  messagingByConceptId(
    conceptId: $conceptId
    trigger: $trigger
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      conceptId
      operaHotelId
      trigger
      channel
      description
      precedence
      delayMinutes
      subject
      messageTemplate
      header
      footer
      templateName
      templateLanguage
      sendRatingAfter
      ratingLink
      isActive
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      updatedByID
      updatedByName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MessagingByConceptIdQueryVariables,
  APITypes.MessagingByConceptIdQuery
>;
export const getFeature = /* GraphQL */ `query GetFeature($id: ID!) {
  getFeature(id: $id) {
    id
    name
    icon
    slug
    precedence
    parent
    private
    deleted
    createdAt
    createdByID
    createdByName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFeatureQueryVariables,
  APITypes.GetFeatureQuery
>;
export const listFeatures = /* GraphQL */ `query ListFeatures(
  $filter: ModelFeatureFilterInput
  $limit: Int
  $nextToken: String
) {
  listFeatures(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      icon
      slug
      precedence
      parent
      private
      deleted
      createdAt
      createdByID
      createdByName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFeaturesQueryVariables,
  APITypes.ListFeaturesQuery
>;
